
<template>
  <el-menu ref="sideMenu"
           :background-color="backgroundColor"
           :text-color="textColor"
           :collapse="shrink"
           :style="{borderRightColor:backgroundColor}"
           @select="changeMenu"
           @open="openSubmenu">
    <template v-for="item in menuList">
      <el-menu-item v-if="item.children.length<=1"
                    :name="item.children[0].name"
                    :index="item.children[0].name"
                    :key="item.path">
        <k-icon :name="item.icon"
                :size="iconSize"
                :color="textColor"
                :key="item.path_icon"></k-icon>
        <span class="layout-text"
              :key="item.path_path">{{ itemTitle(item) }}</span>
      </el-menu-item>

      <el-submenu v-if="item.children.length > 1"
                  :name="item.name"
                  :index="item.name"
                  :key="item.path">
        <template slot="title">
          <k-icon :name="item.icon"
                  :color="textColor"
                  :size="iconSize"></k-icon>
          <span class="layout-text">{{ itemTitle(item) }}</span>
        </template>
        <template v-for="child in item.children">
          <el-menu-item :name="child.name"
                        :index="child.name"
                        :key="child.name"
                        v-if="child.is_show">
            <k-icon :name="child.icon"
                    :size="iconSize"
                    :color="textColor"
                    :key="child.name_icon"></k-icon>
            <span class="layout-text"
                  :key="child.name_span">{{ child.title }}</span>
          </el-menu-item>
        </template>
      </el-submenu>
    </template>
  </el-menu>
</template>

<script>
export default {
  name: 'sidebarMenu',
  props: {
    shrink: false,
    menuList: Array,
    iconSize: Number,
    theme: {
      type: String,
      default: 'dark'
    },
    openNames: {
      type: Array
    },
  },
  computed: {
    backgroundColor () {
      return this.theme === 'dark' ? '#495060' : '#fff'
    },
    textColor () {
      return this.theme === 'light' ? '#495060' : '#fff'
    }
  },
  methods: {
    changeMenu (index, indexPath) {
      this.$router.push({
        name: index
      })
    },
    openSubmenu (index, indexPath) {

    },
    itemTitle (item) {
      if (typeof item.title === 'object') {
        return this.$t(item.title.i18n);
      } else {
        return item.title;
      }
    }
  },
  updated () {
    this.$nextTick(() => {
      if (this.$refs.sideMenu) {
        //this.$refs.sideMenu.updateOpened();
      }
    });
  }

};
</script>

<style lang="scss" scoped>
.ivu-shrinkable-menu {
  height: 100%;
  width: 100%;
}
</style>
